import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/',
    component: () => import('@/layout/MainLayout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue')
      },
      {
        path: 'users',
        name: 'UserManagement',
        component: () => import('@/views/UserManagement.vue')
      },
      {
        path: 'change-password',
        name: 'ChangePassword',
        component: () => import('@/views/ChangePassword.vue')
      },
      {
        path: 'contracts',
        name: 'ContractManagement',
        component: () => import('@/views/ContractManagement.vue')
      }
    ]
  }
]

const router = new Router({
  routes
})

// 路由守卫
router.beforeEach((to, _from, next) => {
  const token = localStorage.getItem('token')
  console.log('[Router] 路由守卫:', { path: to.path, hasToken: !!token })

  if (to.path === '/login') {
    // 已登录用户访问登录页，跳转到首页
    if (token) {
      console.log('[Router] 已登录，跳转到首页')
      next('/dashboard')
    } else {
      console.log('[Router] 未登录，进入登录页')
      next()
    }
  } else {
    // 访问其他页面需要登录
    if (token) {
      console.log('[Router] 已登录，允许访问')
      next()
    } else {
      console.log('[Router] 未登录，跳转登录页')
      next('/login')
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js